import { api } from './api';


const companyAPI = {
  getCompanyDetails: () => api.get('/api/company/details'),
  updateCompany: (company) => api.put('/api/company', company),
};

export default companyAPI;
